import styled from 'styled-components/macro';
import { FocusableParent } from 'components/navigation';
import scaleSize from 'utils/scale-size';

export const StyledContinueWatchingPage = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
`;

export const TabContentWrapper = styled.div`
  width: ${scaleSize(1135)}px;
  height: ${scaleSize(1080)}px;
  margin: ${scaleSize(65)}px 0 0 ${scaleSize(95)}px;
  position: relative;
  white-space: normal;
`;

export const WithoutContentWrapper = styled(FocusableParent)`
  width: ${scaleSize(700)}px;
  height: ${scaleSize(400)}px;
  text-align: center;
  position: absolute;
  top: ${scaleSize(250)}px;
  left: 50%;
  transform: translateX(-50%);
  > a {
    margin-right: 0;
  }
`;

export const WithoutContentText = styled.div`
  font-size: ${scaleSize(40)}px;
  margin-top: ${scaleSize(20)}px;
  margin-bottom: ${scaleSize(50)}px;
  line-height: 1.2;
  text-align: center;
  color: #9f9f9f;
`;
